import { useQuery } from '@tanstack/react-query';
import { plansUpgradeService } from '../plans-upgrade.service';
import type {
	TUseUpgradeModalitiesConfig,
	TUseUpgradeModalitiesReturn
} from './use-upgrade-modalities.types';

/**
 * Hook para listar modalidades de upgrade disponíveis
 *
 * @example
 * ```tsx
 * const { modalities, isLoading } = useUpgradeModalities({
 *   vehicleType: 'car',
 *   advertiseId: 12345,
 *   enabled: true
 * });
 * ```
 */
const useUpgradeModalities = (config: TUseUpgradeModalitiesConfig): TUseUpgradeModalitiesReturn => {
	const { vehicleType, advertiseId, enabled = true } = config;

	const { data, isLoading, isError, error, refetch, isFetching } = useQuery({
		queryKey: ['plans', 'upgrade', vehicleType, advertiseId],
		queryFn: () => plansUpgradeService.listUpgradeModalities(vehicleType, advertiseId),
		enabled: enabled && !!advertiseId
	});

	return {
		modalities: data ?? [],
		isLoading,
		isError,
		error: error as Error | null,
		refetch: () => {
			void refetch();
		},
		isFetching
	};
};

export { useUpgradeModalities };
